var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendLater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1809_40740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.0653V10.7215L15.2 12M20 11C20 15.4183 16.4183 19 12 19C7.58172 19 4 15.4183 4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9863 14.5767C12.9863 14.5767 13.0709 14.4546 13.142 14.4346C13.2238 14.4116 13.3471 14.4677 13.5938 14.58L21.4432 18.1535C21.6847 18.2634 21.8054 18.3184 21.8428 18.3948C21.8752 18.4611 21.8752 18.539 21.8428 18.6053C21.8054 18.6817 21.6847 18.7367 21.4432 18.8466L13.5965 22.4188C13.3491 22.5315 13.2254 22.5878 13.1435 22.5647C13.0724 22.5446 12.9879 22.4222 12.9879 22.4222L12.9863 14.5767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5509 18.5001H13.0954M13.5965 22.4188L21.4432 18.8466C21.6847 18.7367 21.8054 18.6817 21.8428 18.6053C21.8752 18.539 21.8752 18.4611 21.8428 18.3948C21.8054 18.3184 21.6847 18.2634 21.4432 18.1535L13.5938 14.58C13.3471 14.4677 13.2238 14.4116 13.142 14.4346C13.0709 14.4546 12.9863 14.5767 12.9863 14.5767L12.9879 22.4222C12.9879 22.4222 13.0724 22.5446 13.1435 22.5647C13.2254 22.5878 13.3491 22.5315 13.5965 22.4188Z",
    stroke: "#F9F9F9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5509 18.5001H13.0954M13.5965 22.4188L21.4432 18.8466C21.6847 18.7367 21.8054 18.6817 21.8428 18.6053C21.8752 18.539 21.8752 18.4611 21.8428 18.3948C21.8054 18.3184 21.6847 18.2635 21.4432 18.1535L13.5938 14.58C13.3471 14.4677 13.2238 14.4116 13.142 14.4346C13.0709 14.4546 12.9863 14.5767 12.9863 14.5767L12.9879 22.4222C12.9879 22.4222 13.0724 22.5446 13.1435 22.5647C13.2254 22.5878 13.3491 22.5315 13.5965 22.4188Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1809_40740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLater);
export default __webpack_public_path__ + "static/media/send-later.91ffde02a7ed0e6d6a005afebad59206.svg";
export { ForwardRef as ReactComponent };